<template>
  <form class="c-project__versions-form c-form u-mts" @submit.prevent="submit">
    <!-- versions -->
    <fieldset class="c-form__fields">
      <div class="c-banner u-mbs">
        <h1 class="c-banner__title">{{ isEdit ? t('editVersion') : t('createNewVersion') }}</h1>
      </div>
      <Draggable
        v-if="isEditAllVersions"
        tag="ul"
        :list="versionsList"
        class="list-group"
        handle=".handle"
        item-key="name"
        @end="updateVersionsListOrder"
      >
        <template #item="{ element, index }">
          <li :class="element.is_tagged ? 'list-group-item-selected' : ''" class="list-group-item c-version-edit__list-item" :item-index="index" :item-key="element" @click="selectEditVersion(index)">
            <i class="fa fa-align-justify handle" />
            <div ref="taggedIcon" :item-pk="element.pk" class="c-version-edit__tag-icon" @click="setTaggedVersion(index, $event)">
              <i :item-pk="element.pk" :class="element.is_tagged ? 'fa-solid' : 'fa-regular'" class="fa-star" />
            </div>
            <p class="c-version-edit__draggable-name">{{ element.name }} </p>
            <p v-if="versionsData" class="c-version-edit__draggable-date">{{ versionsData[index] ? versionsData[index].date_published?.slice(0, 10) : '' }}</p>
            <!-- <i class="fa fa-times close" @click="removeAt(index)"></i> -->
          </li>
        </template>
      </Draggable>
      <div v-if="isEditAllVersions" class="c-version-edit__add-item u-mbs" :loading="isLoading" @click="addNewVersion(versionsList)">
        <i class="fa fa-align-justify fa-solid fa-plus" />
      </div>
      <!-- <div class="c-version-edit__button-container">
        <Btn v-if="isEditAllVersions" ref="versionAddButton" :loading="isLoading" :label="t('addNewVersion')" class="c-version-edit__add-button u-mbs" @click="addNewVersion" />
      </div> -->
      <!-- version number -->
      <div class="c-form__field c-field">
        <div class="c-field__wrapper">
          <label for="version_number" class="c-field__label">
            {{ t('versionNumber') }}
          </label>
          <input
            id="version-number"
            :value="modelValue.versionNumber"
            type="text"
            name="version_number"
            class="c-field__input"
            :disabled="isLoading"
            @input="inputVersion"
          >
          <!-- safe to use here as it's a static string -->
          <!-- eslint-disable-next-line vue/no-v-html -->
          <small class="c-field__hint" v-html="t('versionNumberHint')" />
        </div>
      </div>
      <div class="c-form__field c-field">
        <!-- name -->
        <div class="c-field__wrapper">
          <label for="version_name" class="c-field__label">
            {{ t('name') }}
          </label>
          <input
            id="version-name"
            :value="modelValue.name"
            type="text"
            name="version_name"
            class="c-field__input"
            :disabled="isLoading"
            @input="inputName"
          >
          <!-- safe to use here as it's a static string -->
          <!-- eslint-disable-next-line vue/no-v-html -->
          <small class="c-field__hint" v-html="t('nameHint')" />
        </div>
      </div>
      <!-- description -->
      <div class="c-form__field c-field">
        <div class="c-field__wrapper">
          <label for="version_description" class="c-field__label">
            {{ t('description') }}
          </label>
          <textarea
            id="version-description"
            :value="modelValue.description"
            type="text"
            name="version_description"
            class="c-field__input"
            :disabled="isLoading"
            @input="inputDescripion"
          />
          <!-- safe to use here as it's a static string -->
          <!-- eslint-disable-next-line vue/no-v-html -->
          <small class="c-field__hint">{{ t('descriptionHint') }}</small>
        </div>
      </div>
      <!-- release notes -->
      <div class="c-form__field c-field">
        <div class="c-field__wrapper">
          <label for="release_notes" class="c-field__label">{{ t('releaseNotes') }}</label>
          <textarea
            id="release-notes"
            :value="modelValue.releaseNotes"
            type="text"
            name="release_notes"
            class="c-field__input"
            :disabled="isLoading"
            @input="inputReleaseNotes"
          />
          <!-- safe to use here as it's a static string -->
          <!-- eslint-disable-next-line vue/no-v-html -->
          <small class="c-field__hint">{{ t('releaseNotesHint') }}</small>
        </div>
      </div>
      <!-- date of publication -->
      <div class="c-form__field c-field">
        <div class="c-field__wrapper">
          <label for="date_published" class="c-field__label">{{ t('publicationDate') }}</label>
          <input
            id="date-published"
            :value="modelValue.datePublished ? modelValue.datePublished.split('T')[0] : ''"
            :disabled="isLoading"
            type="date"
            name="date_published"
            class="c-field__input c-field__input--inline c-field__input--date"
            @input="inputDate"
          >
        </div>
      </div>
      <!-- status -->
      <div class="c-form__field c-field">
        <div class="c-field__wrapper">
          <span class="c-field__label">{{ t('status') }}</span>
          <label class="c-field__choice">
            <input
              type="radio"
              :disabled="isLoading"
              name="version_status"
              value="0"
              :checked="modelValue.status == '0'"
              class="c-field__input"
              @input="inputStatus"
            >
            <span class="c-field__text">
              {{ t('draft') }}
            </span>
          </label>
          <label class="c-field__choice">
            <input
              type="radio"
              :disabled="isLoading"
              name="version_status"
              value="1"
              class="c-field__input"
              :checked="modelValue.status == '1'"
              @input="inputStatus"
            >
            <span class="c-field__text">
              {{ t('published') }}
            </span>
          </label>
          <label class="c-field__choice">
            <!-- @ts-expect-error -->
            <input
              type="radio"
              :disabled="isLoading"
              name="version_status"
              value="2"
              :checked="modelValue.status == '2'"
              class="c-field__input"
              @input="inputStatus"
            >
            <span class="c-field__text">
              {{ t('archived') }}
              <!-- <div class="u-mtxs">
                <small class="c-field__hint">{{ t('statusHint') }}</small>
              </div> -->
            </span>
          </label>
        </div>
      </div>
      <!-- create assets actions buttons -->
      <fieldset v-if="!isEditAllVersions" class="c-form__actions">
        <Btn ref="versionCancelButton" :loading="isLoading" :disabled="versionCancelButtonDisabled" :label="t('cancel')" :style="{ opacity: 1 }" class="c-button-cancel cancel-button-versions-create" @click="toggleVersionsForm('cancel')" />
        <Btn ref="versionConfirmButton" :loading="isLoading" :disabled="versionConfirmButtonDisabled" :label="isEdit ? t('saveVersion') : t('save')" :style="{ opacity: versionConfirmBtnOpacity }" class="c-button-confirm confirm-button-versions-create" @click="toggleAssetsForm('confirm')" />
      </fieldset>
      <!-- edit versions actions buttons -->
      <fieldset v-if="isEditAllVersions" class="c-form__actions u-flex">
        <div class="delete-version-tagged-warning c-message c-message--warning u-align-center u-mbs u-hide">
          <small>{{ t('deleteVersionTaggedWarning') }}</small>
        </div>
        <Btn ref="versionCancelEditButton" :loading="isLoading" :disabled="isLoading" :label="t('cancel')" class="c-button-cancel cancel-button-versions-create" @click="toggleVersionsForm('cancel')" />
        <BtnSubmit ref="versionConfirmEditButton" :loading="isLoading" :disabled="isLoading" :label="isEdit ? t('saveVersion') : t('createVersion')" />
        <!-- delete version popup -->
        <Popover
          trigger="manual"
          :show="confirmVersionDelete"
          theme="danger"
          placement="top"
          @click-outside="confirmVersionDelete = false"
        >
          <template #button>
            <!-- <button
              class="c-button c-button--small c-button--light"
              :disabled="deleteVersion.loading"
              @click.prevent="confirmDeletion"
            >
              <SVGIcon v-if="!deleteVersion.loading" class="c-button__icon" name="trash" />
              <SVGIcon v-else class="c-button__icon" name="spinner-thin" />
              <span class="c-button__label">{{ t('delete') }}</span>
            </button> -->
            <Btn ref="versionDeleteButton" :loading="isLoading" :disabled="isLoading" :label="t('delete')" class="c-button-delete delete-button-versions-edit" @click="confirmVersionDeletion" />
          </template>
          <template #tooltip>
            <span>{{ t('clickAgainToConfirm') }}</span>
          </template>
        </Popover>
      </fieldset>
    </fieldset>
    <!-- assets -->
    <div ref="assetsForm" class="c-project__assets-form-container">
      <!-- assets edit -->
      <template v-if="(isEditAssets || isEditAllVersions) && !isAddingNewAsset">
        <fieldset class="c-project__assets-form-field">
          <fieldset class="c-form__fields">
            <div class="c-banner u-mbs">
              <h1 class="c-banner__title">{{ isEdit ? t('editAsset') : t('createNewAsset') }}</h1>
            </div>
            <Draggable
              v-if="isEditAllVersions"
              tag="ul"
              :list="assetsList"
              :disabled="true"
              class="list-group"
              handle=".handle"
              item-key="name"
              @end="updateAssetsListOrder"
            >
              <template #item="{ element, index }">
                <li :class="index === 0 ? 'list-group-item-selected' : ''" class="list-group-item c-asset-edit__list-item" :item-index="index" :item-key="element" @click="selectEditAsset(index)">
                  <!-- <i class="fa fa-align-justify handle u-mrs" /> -->
                  <i v-if="element.access_url" class="fa fa-align-justify fa-link" />
                  <i v-else class="fa fa-align-justify fa-file" />
                  <p class="c-asset-edit__draggable-name">{{ element.name ? element.name : (element.filename ? element.filename : 'asset') }} </p>
                  <p v-if="(element.platform != '3' && element.platform != '4')" class="c-asset-edit__draggable-platform">{{ setPlatformName(element.platform) }}</p>
                  <div ref="deleteAssetIcon" class="c-asset-edit__delete-icon" @click="removeAsset">
                    <i :item-pk="element.pk" class="fa fa-trash" />
                  </div>
                </li>
              </template>
            </Draggable>
            <div v-if="isEditAllVersions" class="c-asset-edit__add-item u-mbs" :loading="isLoading" @click="toggleCreateNewAssetForm">
              <i class="fa fa-align-justify fa-solid fa-plus" />
            </div>
            <!-- <div class="c-version-edit__button-container">
              <Btn v-if="isEditAllVersions" ref="assetAddButton" :loading="isLoading" :label="t('addNewAsset')" class="c-asset-edit__add-button u-mbs" @click="toggleCreateNewAssetForm" />
            </div> -->
            <div class="c-form__field c-field">
              <!-- name -->
              <div class="c-field__wrapper">
                <label for="asset_name" class="c-field__label">
                  {{ t('name') }}
                </label>
                <input
                  id="asset-name"
                  :value="modelValue.assetName"
                  type="text"
                  name="asset_name"
                  class="c-field__input"
                  :disabled="loading"
                  @input="inputAssetName"
                >
              </div>
            </div>
            <div ref="assetsUploadField" class="c-project__assets-form u-mts">
              <div v-if="!isEditAllVersions" class="u-mbs">
                <label class="c-field__label">{{ t('upload') }}</label>
                <div class="c-message c-message--warning u-align-center u-mbs u-hide">
                  <small>{{ t('assetUploadWarning') }}</small>
                </div>
                <ProjectAssetsField
                  v-if="!isEditAllVersions"
                  :editable="!isEdit"
                  :model-value="modelValue.assets"
                  @update:is-uploading="isAssetUploading = $event"
                  @update:is-error="isAssetError = $event"
                  @update:model-value="$emit('update:modelValue', { ...modelValue, assets: $event })"
                />
                <div v-if="isEdit && modelValue.assets.length === 0">
                  <small class="c-field__hint">{{ t('noAssetsUploaded') }}</small>
                </div>
              </div>
            </div>
            <!-- description -->
            <div class="c-form__field c-field">
              <div class="c-field__wrapper">
                <label for="asset_description" class="c-field__label">{{ t('description') }}</label>
                <textarea
                  id="asset-description"
                  :value="modelValue.assetDescription"
                  type="text"
                  name="asset_description"
                  class="c-field__input"
                  :disabled="loading"
                  @input="inputAssetDescription"
                />
              </div>
            </div>
            <!-- platform -->
            <div class="c-form__field c-field">
              <div class="c-field__wrapper">
                <span class="c-field__label">{{ t('platform') }}</span>
                <label class="c-field__choice">
                  <input
                    type="radio"
                    :disabled="loading"
                    name="asset_platform"
                    value="0"
                    :checked="modelValue.assetPlatform == '0'"
                    class="c-field__input"
                    @input="inputAssetPlatform"
                  >
                  <span class="c-field__text">
                    macOS
                  </span>
                </label>
                <label class="c-field__choice">
                  <input
                    type="radio"
                    :disabled="loading"
                    name="asset_platform"
                    value="1"
                    :checked="modelValue.assetPlatform == '1'"
                    class="c-field__input"
                    @input="inputAssetPlatform"
                  >
                  <span class="c-field__text">
                    Windows
                  </span>
                </label>
                <label class="c-field__choice">
                  <!-- @ts-expect-error -->
                  <input
                    type="radio"
                    :disabled="loading"
                    name="asset_platform"
                    value="2"
                    :checked="modelValue.assetPlatform == '2'"
                    class="c-field__input"
                    @input="inputAssetPlatform"
                  >
                  <span class="c-field__text">
                    Linux
                  </span>
                </label>
                <label class="c-field__choice">
                  <input
                    type="radio"
                    :disabled="loading"
                    name="asset_platform"
                    value="3"
                    :checked="modelValue.assetPlatform == '3'"
                    class="c-field__input"
                    @input="inputAssetPlatform"
                  >
                  <span class="c-field__text">
                    {{ t('other') }}
                  </span>
                </label>
                <!-- <input
                  id="asset-platform-detail"
                  type="text"
                  name="asset-platform-detail"
                  class="c-field__input"
                  placeholder="Details: OS version number, name, architecture, etc."
                  :disabled="loading"
                > -->
              </div>
            </div>
            <!-- notes -->
            <div class="c-form__field c-field">
              <div class="c-field__wrapper">
                <label for="asset_notes" class="c-field__label">Notes</label>
                <textarea
                  id="asset-notes"
                  :value="modelValue.assetNotes"
                  type="text"
                  name="asset_notes"
                  class="c-field__input"
                  :disabled="isLoading"
                  @input="inputAssetNotes"
                />
              </div>
            </div>
            <!-- premium -->
            <div v-if="isInternalUser" class="c-form__field c-field">
              <div class="c-field__wrapper">
                <label for="asset-premium" class="c-field__label">{{ t('premium') }}</label>
                <input
                  id="asset-premium"
                  type="checkbox"
                  name="asset-premium"
                  class="c-field__input"
                  :checked="modelValue.assetIsPremium"
                  :disabled="loading"
                  @input="inputAssetIsPremium"
                >
              </div>
            </div>
            <!-- unlock url -->
            <!-- <div v-if="project.is_protected" class="c-form__field c-field">
              <div class="c-field__wrapper">
                <label for="asset_unlock_url" class="c-field__label">{{ t('assetUnlockUrl') }}</label>
                <input
                  id="asset-unlock-url"
                  :value="modelValue.assetUnlockUrl"
                  type="text"
                  name="asset_unlock_url"
                  class="c-field__input"
                  :disabled="loading"
                  @input="inputAssetUnlockUrl"
                >
              </div>
            </div> -->
            <!-- edit assets actions buttons -->
            <div class="delete-last-asset-warning c-message c-message--warning u-align-center u-mts u-hide">
              <small>{{ t('deleteLastAssetWarning') }}</small>
            </div>
            <fieldset v-if="isEditAllVersions" class="c-form__actions u-flex">
              <Btn ref="assetCancelEditButton" :loading="isLoading" :disabled="isLoading" :label="t('cancel')" class="c-button-cancel cancel-button-assets-create" @click="toggleVersionsForm('cancel')" />
              <Btn ref="assetConfirmEditButton" :loading="isLoading" :disabled="isLoading" :label="t('saveAsset')" class="c-button-confirm confirm-button-assets-create" @click="submitAssets" />
              <!-- delete asset popup -->
              <Popover
                trigger="manual"
                :show="confirmAssetDelete"
                theme="danger"
                placement="top"
                @click-outside="confirmAssetDelete = false"
              >
                <template #button>
                  <!-- <button
                    class="c-button c-button--small c-button--light"
                    :disabled="deleteVersion.loading"
                    @click.prevent="confirmDeletion"
                  >
                    <SVGIcon v-if="!deleteVersion.loading" class="c-button__icon" name="trash" />
                    <SVGIcon v-else class="c-button__icon" name="spinner-thin" />
                    <span class="c-button__label">{{ t('delete') }}</span>
                  </button> -->
                  <Btn ref="assetDeleteButton" :loading="isLoading" :disabled="isLoading" :label="t('delete')" class="c-button-delete delete-button-assets-edit" @click="confirmAssetDeletion" />
                </template>
                <template #tooltip>
                  <span>{{ t('clickAgainToConfirm') }}</span>
                </template>
              </Popover>
            </fieldset>
            <!-- submit -->
            <fieldset class="c-form__actions">
              <div class="c-project__asset-form-message">
                <div v-if="showAssetUploading" class="c-message c-message--warning u-align-center u-mbs">
                  <small>{{ t('assetUploading') }}</small>
                </div>
                <div v-if="showAssetError" class="c-message c-message--warning u-align-center u-mbs">
                  <small>{{ t('assetError') }}</small>
                </div>
                <div v-if="error" class="c-message c-message--error u-align-center u-mbs">
                  <small>{{ error.apiMessage ?? (isEdit ? t('unknownErrorEdit') : t('unknownErrorCreate')) }}</small>
                </div>
              </div>
              <div class="c-project__asset-form-buttons">
                <Btn v-if="!isEditAllVersions" ref="versionCancelCreateButton" :loading="isLoading" :disabled="isLoading" :label="t('cancel')" class="c-button-cancel cancel-button-versions-create" @click="toggleVersionsForm('cancel')" />
                <BtnSubmit v-if="!isEditAllVersions" :loading="loading" :label="isEdit ? t('saveVersion') : t('createVersion')" class="confirm-button-assets-create" />
              </div>
            </fieldset>
            <!-- safe to use here as it's a static string -->
            <!-- eslint-disable-next-line vue/no-v-html -->
            <p v-if="!isEdit" class="u-mts c-form__links" v-html="t('createInfo')" />
          </fieldset>
        </fieldset>
      </template>
      <!-- create new asset -->
      <template v-if="isEditAllVersions && isAddingNewAsset">
        <form class="c-project__assets-form c-form" @submit.prevent="addNewAsset">
          <fieldset class="c-project__assets-form-field u-mts">
            <fieldset class="c-form__fields">
              <div class="c-banner u-mbs">
                <h1 class="c-banner__title">{{ t('createNewAsset') }}</h1>
              </div>
              <div class="c-form__field c-field">
                <!-- name -->
                <div class="c-field__wrapper">
                  <label for="asset_name" class="c-field__label">
                    {{ t('name') }}
                  </label>
                  <input
                    id="asset-name"
                    :value="newAsset.name"
                    type="text"
                    name="asset_name"
                    class="c-field__input"
                    :disabled="loading"
                    @input="inputNewAssetName"
                  >
                </div>
              </div>
              <div ref="assetsUploadField" class="c-project__new-asset-form u-mts">
                <div class="u-mbs">
                  <label class="c-field__label">{{ t('upload') }}</label>
                  <div class="c-message c-message--warning u-align-center u-mbs u-hide">
                    <small>{{ t('assetUploadWarning') }}</small>
                  </div>
                  <ProjectAssetsField
                    :editable="true"
                    :model-value="modelValue.assets"
                    @update:is-uploading="isAssetUploading = $event"
                    @update:is-error="isAssetError = $event"
                    @update:model-value="$emit('update:modelValue', { ...modelValue, assets: $event })"
                  />
                </div>
              </div>
              <!-- description -->
              <div class="c-form__field c-field">
                <div class="c-field__wrapper">
                  <label for="asset_description" class="c-field__label">{{ t('description') }}</label>
                  <textarea
                    id="asset-description"
                    :value="newAsset.label"
                    type="text"
                    name="asset_description"
                    class="c-field__input"
                    :disabled="loading"
                    @input="inputNewAssetDescription"
                  />
                </div>
              </div>
              <!-- platform -->
              <div class="c-form__field c-field">
                <div class="c-field__wrapper">
                  <span class="c-field__label">{{ t('platform') }}</span>
                  <label class="c-field__choice">
                    <input
                      type="radio"
                      :disabled="loading"
                      name="asset_platform"
                      value="0"
                      :checked="newAsset.platform == '0'"
                      class="c-field__input"
                      @input="inputNewAssetPlatform"
                    >
                    <span class="c-field__text">
                      macOS
                    </span>
                  </label>
                  <label class="c-field__choice">
                    <input
                      type="radio"
                      :disabled="loading"
                      name="asset_platform"
                      value="1"
                      :checked="newAsset.platform == '1'"
                      class="c-field__input"
                      @input="inputNewAssetPlatform"
                    >
                    <span class="c-field__text">
                      Windows
                    </span>
                  </label>
                  <label class="c-field__choice">
                    <!-- @ts-expect-error -->
                    <input
                      type="radio"
                      :disabled="loading"
                      name="asset_platform"
                      value="2"
                      :checked="newAsset.platform == '2'"
                      class="c-field__input"
                      @input="inputNewAssetPlatform"
                    >
                    <span class="c-field__text">
                      Linux
                    </span>
                  </label>
                  <label class="c-field__choice">
                    <input
                      type="radio"
                      :disabled="loading"
                      name="asset_platform"
                      value="3"
                      :checked="newAsset.platform == '3'"
                      class="c-field__input"
                      @input="inputNewAssetPlatform"
                    >
                    <span class="c-field__text">
                      {{ t('other') }}
                    </span>
                  </label>
                  <!-- <input
                    id="asset-platform-detail"
                    type="text"
                    name="asset-platform-detail"
                    class="c-field__input"
                    placeholder="Details: OS version number, name, architecture, etc."
                    :disabled="loading"
                  > -->
                </div>
              </div>
              <!-- notes -->
              <div class="c-form__field c-field">
                <div class="c-field__wrapper">
                  <label for="asset_notes" class="c-field__label">Notes</label>
                  <textarea
                    id="asset-notes"
                    :value="newAsset.notes"
                    type="text"
                    name="asset_notes"
                    class="c-field__input"
                    :disabled="loading"
                    @input="inputNewAssetNotes"
                  />
                </div>
              </div>
              <!-- premium -->
              <div v-if="isInternalUser" class="c-form__field c-field">
                <div class="c-field__wrapper">
                  <label for="asset-premium" class="c-field__label">{{ t('premium') }}</label>
                  <input
                    id="asset-premium"
                    type="checkbox"
                    name="asset-premium"
                    class="c-field__input"
                    :checked="project.is_premium"
                    :disabled="loading"
                    @input="inputNewAssetIsPremium"
                  >
                </div>
              </div>
              <!-- unlock url -->
              <!-- <div v-if="project.is_protected" class="c-form__field c-field">
                <div class="c-field__wrapper">
                  <label for="asset_unlock_url" class="c-field__label">{{ t('assetUnlockUrl') }}</label>
                  <input
                    id="asset-unlock-url"
                    :value="newAsset.unlockUrl"
                    type="text"
                    name="asset_unlock_url"
                    class="c-field__input"
                    :disabled="loading"
                    @input="inputNewAssetUnlockUrl"
                  >
                </div>
              </div> -->
            </fieldset>
          </fieldset>
          <!-- create new asset actions buttons -->
          <fieldset class="c-form__actions">
            <Btn ref="assetCancelEditButton" :loading="isLoading" :disabled="assetCancelEditButtonDisabled" :label="t('cancel')" class="c-button-cancel cancel-button-assets-create" @click="toggleVersionsForm('cancel')" />
            <BtnSubmit ref="assetConfirmEditButton" :loading="isLoading" :disabled="assetConfirmEditButtonDisabled" :label="t('createNewAsset')" class="c-button-confirm confirm-button-assets-create u-mls" />
          </fieldset>
        </form>
      </template>
    </div>
  </form>
</template>

<script setup lang="ts">
import { ref, Ref, onMounted, watchEffect } from 'vue'
import { Project, ProjectRelease, Version, VersionList, Asset, APIError, getProjectVersion, editProjectVersionOrder, editProjectVersionTagged, editProjectAssetOrder } from '@/utils/api'
import { useI18n } from '@/utils/i18n'
import ProjectAssetsField from '@/components/ProjectAssetsField.vue'
import Btn from '@/components/buttons/Btn.vue'
import BtnSubmit from '@/components/buttons/BtnSubmit.vue'
import Popover from '@/components/Popover.vue'
import Draggable from 'vuedraggable'

export interface VersionForm {
  name: string
  description: string
  versionNumber: string
  datePublished: string
  releaseNotes: string
  status: string
  assets: Asset[]
  assetName?: string
  assetDescription?: string
  assetNotes?: string
  assetPlatform?: string
  assetIsPremium?: boolean
  assetUnlockUrl?: string
}

export interface AssetForm {
  name: string
  label?: string
  platform?: string
  platformDetails?: string
  notes?: string
  isPremium?: boolean
  unlockUrl?: string
}

const props = withDefaults(defineProps<{
  modelValue: VersionForm
  project: Project
  loading: boolean
  error?: APIError
  isEdit?: boolean
  isEditAllVersions?: boolean
  isInternalUser?: boolean
}>(), { error: undefined, isEdit: false, isEditAllVersions: false, isInternalUser: false })

const emit = defineEmits<{
  (e: 'addNewVersion', list: VersionList[]): void
  (e: 'addNewAsset', newAssetForm: AssetForm): void
  (e: 'selectEditVersion', pk: number): void
  (e: 'selectEditAsset', pk: number): void
  (e: 'updateVersionsOrder', versionsList: Version[]): void
  (e: 'updateVersionsTagged', versionsList: Version[]): void
  (e: 'updateAssetsOrder', assetsList: Asset[]): void
  (e: 'canceled'): void
  (e: 'update:modelValue', version: VersionForm): void
  (e: 'deletedVersion'): void
  (e: 'deletedAsset'): void
  (e: 'submitVersion'): void
  (e: 'submitAsset'): void
  (e: 'saveAsset'): void
}>()

const project = ref(props.project)
// console.log('PROJECT: ', project.value)

const versions = ref(project.value?.releases)
console.log('VERSIONS: ', versions.value)

// version form state
const isLoading = ref(false)
const isEditAssets = ref(false)

// assets form
const assetsForm = ref<HTMLElement>()

// versions order
const orders: Ref<number[]> = ref([])

async function setVersionsInitialOrder () {
  const versionsInOrder: Ref<ProjectRelease[]> = ref([])

  // check if there are versions with null orders
  const hasNullOrder = ref(false)
  versions.value.forEach(version => {
    if (version.release_order === null) {
      hasNullOrder.value = true
    }
  })

  for (const index in versions.value) {
    let order: number

    if (hasNullOrder.value) {
      // check if at least one version is null, in case we map the order linearly
      order = parseInt(index)
      versions.value[parseInt(index)].release_order = order
    } else {
      // otherwhise map all versions release_order
      order = versions.value[parseInt(index)].release_order
    }

    orders.value.push(order)

    versionsInOrder.value[order] = versions.value[parseInt(index)]
  }
  versions.value = versionsInOrder.value

  emit('updateVersionsOrder', versions.value as unknown as Version[])
}

await setVersionsInitialOrder()

// versions draggable list
const versionsList = ref(versions.value)
// console.log('versionsList: ', versionsList.value)

const versionsData = ref<Version[]>()
versionsData.value = []
for (const index in versionsList.value) {
  versionsData.value?.push(await getProjectVersion(versionsList.value[index].pk))
}
// console.log('versionsData: ', versionsData.value)

const selectedVersionPk = ref()

if (versions.value.length) {
  const isTaggedValues: Boolean[] = []
  for (const index in versions.value) {
    const val: boolean = versions.value[index].is_tagged!
    isTaggedValues.push(val)

    if (versions.value[index].is_tagged) {
      selectedVersionPk.value = versions.value[index].pk
    }
  }
  const taggedValue = isTaggedValues.filter(t => t === true)
  if (!taggedValue.length) {
    if (versions.value[0]) {
      versions.value[0].is_tagged = true
      selectedVersionPk.value = versions.value[0].pk
    }
  }
}

// assets draggable list
const assetsList = ref<Asset[]>()
// set tagged version assets as initial assets list
for (const index in versions.value) {
  if (versions.value[index].is_tagged) {
    assetsList.value = (await getProjectVersion(versions.value[index].pk)).assets
  }
}

// select version from draggable list
async function selectEditVersion (index: number) {
  if (versionsList.value) {
    const pk = versionsList.value[index].pk

    assetsList.value = (await getProjectVersion(pk)).assets

    // set selected item background color
    const versionsListItemElements = ref(document.getElementsByClassName('c-version-edit__list-item'))
    for (let i = 0; i < versionsListItemElements.value.length; i++) {
      versionsListItemElements.value[i].classList.remove('list-group-item-selected')
    }
    versionsListItemElements.value[index].classList.add('list-group-item-selected')

    selectedVersionPk.value = pk

    emit('selectEditVersion', pk)
  }
}

// select asset from draggable list
async function selectEditAsset (index: number) {
  if (assetsList.value) {
    await saveAsset()

    assetsList.value = (await getProjectVersion(selectedVersionPk.value)).assets

    const pk = assetsList.value[index].pk

    // set selected item background color
    const assetsListItemElements = ref(document.getElementsByClassName('c-asset-edit__list-item'))
    for (let i = 0; i < assetsListItemElements.value.length; i++) {
      assetsListItemElements.value[i].classList.remove('list-group-item-selected')
    }
    assetsListItemElements.value[index].classList.add('list-group-item-selected')

    emit('selectEditAsset', pk)
  }
}

async function updateVersionsListOrder () {
  // update versions order
  for (const index in versionsList.value) {
    const body = {
      name: versionsList.value[parseInt(index)].name,
      description: versionsList.value[parseInt(index)].description,
      release_order: parseInt(index)
    }
    await editProjectVersionOrder(versionsList.value[parseInt(index)].pk, body)
  }
  emit('updateVersionsOrder', versionsList.value as unknown as Version[])
}

async function updateAssetsListOrder () {
  console.log('assetsList: ', assetsList.value)

  // update assets order
  for (const index in assetsList.value) {
    const body = {
      name: assetsList.value[parseInt(index)].name,
      order: parseInt(index)
    }
    await editProjectAssetOrder(assetsList.value[parseInt(index)].pk, body)
  }
  emit('updateAssetsOrder', assetsList.value as unknown as Asset[])
}

// tagged version
const taggedIcon = ref(HTMLElement)

function setTaggedVersion (index: any, e?: Event) {
  setTaggedIcon(e!)
}

async function getTaggedVersion () {
  const allTagIconElements = document.querySelectorAll('.c-version-edit__tag-icon')
  for (let i = 0; i < allTagIconElements.length; i++) {
    const iconElement = <HTMLElement>allTagIconElements[i].firstChild
    if (iconElement.classList.contains('fa-solid')) {
      const pk = iconElement.getAttribute('item-pk')!
      return await getProjectVersion(parseInt(pk))
    }
  }
}

function setTaggedIcon (e: Event) {
  const target = <HTMLElement>e.target
  const targetPk = target.getAttribute('item-pk')

  if (target.classList.contains('fa-star')) {
    // reset all icons to default
    const allTagIconElements = document.querySelectorAll('.c-version-edit__tag-icon')
    for (let i = 0; i < allTagIconElements.length; i++) {
      const iconElement = <HTMLElement>allTagIconElements[i].firstChild
      iconElement.classList.remove('fa-solid')
      iconElement.classList.add('fa-regular')
    }

    // add solid icon to tagged version
    for (const index in versionsList.value) {
      if (versionsList.value[parseInt(index)].pk === parseInt(targetPk!)) {
        target.classList.remove('fa-regular')
        target.classList.add('fa-solid')
      }
    }
  }
}

// form actions buttons
// const versionAddButton = ref<HTMLButtonElement>()

// const assetAddButton = ref<HTMLButtonElement>()

const versionCancelButton = ref<HTMLButtonElement>()
const versionConfirmButton = ref<HTMLButtonElement>()
const versionDeleteButton = ref<HTMLButtonElement>()

const assetDeleteButton = ref<HTMLButtonElement>()

const versionCancelCreateButton = ref<HTMLButtonElement>()

const versionCancelEditButton = ref<HTMLButtonElement>()
const versionConfirmEditButton = ref<HTMLButtonElement>()

const assetCancelEditButton = ref<HTMLButtonElement>()
const assetConfirmEditButton = ref<HTMLButtonElement>()

const versionCancelButtonDisabled = ref(false)
const versionConfirmButtonDisabled = ref(false)
const versionDeleteButtonDisabled = ref(false)

const assetDeleteButtonDisabled = ref(false)

const versionCancelCreateButtonDisabled = ref(false)

const versionCancelEditButtonDisabled = ref(false)
const versionConfirmEditButtonDisabled = ref(false)

const assetCancelEditButtonDisabled = ref(false)
const assetConfirmEditButtonDisabled = ref(false)

const versionCancelBtnOpacity = ref('0.5')
const versionConfirmBtnOpacity = ref('1.0')

onMounted(() => {
  // init form
  if (versionCancelButton.value) {
    versionCancelButtonDisabled.value = false
  }

  if (versionConfirmButton.value) {
    versionConfirmButtonDisabled.value = false
  }

  if (versionDeleteButton.value) {
    versionDeleteButtonDisabled.value = false
  }

  if (versionCancelCreateButton.value) {
    versionCancelCreateButtonDisabled.value = false
  }

  if (versionCancelEditButton.value) {
    versionCancelEditButtonDisabled.value = false
  }

  if (versionConfirmEditButton.value) {
    versionConfirmEditButtonDisabled.value = false
  }

  if (assetDeleteButton.value) {
    assetDeleteButtonDisabled.value = false
  }

  if (assetCancelEditButton.value) {
    assetCancelEditButtonDisabled.value = false
  }

  if (assetConfirmEditButton.value) {
    assetConfirmEditButtonDisabled.value = false
  }
})
// Versions input events
function inputName (event: Event) {
  const name = (event.currentTarget as HTMLInputElement).value
  emit('update:modelValue', { ...props.modelValue, name })
}

function inputDescripion (event: Event) {
  const description = (event.currentTarget as HTMLInputElement).value
  emit('update:modelValue', { ...props.modelValue, description })
}

function inputVersion (event: Event) {
  const versionNumber = (event.currentTarget as HTMLInputElement).value
  emit('update:modelValue', { ...props.modelValue, versionNumber })
}

function inputReleaseNotes (event: Event) {
  const releaseNotes = (event.currentTarget as HTMLTextAreaElement).value
  emit('update:modelValue', { ...props.modelValue, releaseNotes })
}

function inputDate (event: Event) {
  const datePublished = (event.currentTarget as HTMLInputElement).value
  emit('update:modelValue', { ...props.modelValue, datePublished })
}

function inputStatus (event: Event) {
  const status = (event.currentTarget as HTMLInputElement).value
  // console.log(status)
  emit('update:modelValue', { ...props.modelValue, status })
}

// Assets input events
function inputAssetName (event: Event) {
  const assetName = (event.currentTarget as HTMLInputElement).value
  emit('update:modelValue', { ...props.modelValue, assetName })
}

function inputNewAssetName (event: Event) {
  const newAssetName = (event.currentTarget as HTMLInputElement).value
  newAsset.value.name = newAssetName
}

function inputAssetDescription (event: Event) {
  const assetDescription = (event.currentTarget as HTMLInputElement).value
  emit('update:modelValue', { ...props.modelValue, assetDescription })
}

function inputNewAssetDescription (event: Event) {
  const newAssetDescription = (event.currentTarget as HTMLInputElement).value
  newAsset.value.label = newAssetDescription
}

function inputAssetNotes (event: Event) {
  const assetNotes = (event.currentTarget as HTMLInputElement).value
  emit('update:modelValue', { ...props.modelValue, assetNotes })
}

function inputNewAssetNotes (event: Event) {
  const newAssetNotes = (event.currentTarget as HTMLInputElement).value
  newAsset.value.notes = newAssetNotes
}

function inputAssetPlatform (event: Event) {
  const assetPlatform = (event.currentTarget as HTMLInputElement).value
  emit('update:modelValue', { ...props.modelValue, assetPlatform })
}

function inputNewAssetPlatform (event: Event) {
  const newAssetPlatform = (event.currentTarget as HTMLInputElement).value
  newAsset.value.platform = newAssetPlatform
}

function inputAssetIsPremium (event: Event) {
  const assetIsPremium = Boolean((event.currentTarget as HTMLInputElement).checked)
  emit('update:modelValue', { ...props.modelValue, assetIsPremium })
}

function inputNewAssetIsPremium (event: Event) {
  const inputNewAssetIsPremium = (event.currentTarget as HTMLInputElement).checked
  newAsset.value.isPremium = Boolean(inputNewAssetIsPremium)
}

// function inputAssetUnlockUrl (event: Event) {
//   const assetUnlockUrl = (event.currentTarget as HTMLInputElement).value
//   emit('update:modelValue', { ...props.modelValue, assetUnlockUrl })
// }

// function inputNewAssetUnlockUrl (event: Event) {
//   const newAssetUnlockUrl = (event.currentTarget as HTMLInputElement).value
//   newAsset.value.unlockUrl = newAssetUnlockUrl
// }

// toggle forms
function toggleAssetsForm (action: string) {
  if (action === 'cancel') {
    isEditAssets.value = false

    if (versionCancelButton.value) {
      versionCancelButtonDisabled.value = true
      versionCancelBtnOpacity.value = '0.5'
    }

    if (versionConfirmButton.value) {
      versionConfirmButtonDisabled.value = false
      versionConfirmBtnOpacity.value = '1.0'
    }
  } else if (action === 'confirm') {
    isEditAssets.value = true

    if (versionCancelButton.value) {
      versionCancelButtonDisabled.value = false
      versionCancelBtnOpacity.value = '1.0'
    }

    if (versionConfirmButton.value) {
      versionConfirmButtonDisabled.value = true
      versionConfirmBtnOpacity.value = '0.5'
    }

    // scroll to assets form
    if (assetsForm.value) {
      assetsForm.value.scrollIntoView({ behavior: 'smooth' })
    }
  }
}

function toggleVersionsForm (action: string) {
  if (action === 'cancel') {
    emit('canceled')
  }
}

// add new version
function addNewVersion (list: VersionList[]) {
  isLoading.value = true

  emit('addNewVersion', list)
}

// add new asset
const assetsUploadField = ref<HTMLFieldSetElement>()
const isAddingNewAsset = ref(false)

// init create new asset form values
const initialNewAsset = () => ({
  name: '',
  label: '',
  platform: '4',
  platformDetails: '',
  notes: '',
  isPremium: project.value.is_premium
  // unlockUrl: project.value.protection_unlock_url ? project.value.protection_unlock_url : ''
})

const newAsset = ref<AssetForm>(initialNewAsset())

function toggleCreateNewAssetForm () {
  isAddingNewAsset.value = true

  // // scroll to assets upload field
  // if (assetsUploadField.value) {
  //   assetsUploadField.value.scrollIntoView({ behavior: 'smooth' })
  // }
}

function addNewAsset () {
  // force to add asset if no file uploaded or url
  const existingAssetsListElements = ref(document.querySelectorAll('.c-asset__existing-asset-list-element'))
  const accessUrlElement = ref(document.querySelector('#asset-upload-link') as HTMLInputElement)

  // check if file AND url inputs are not empty
  if ((existingAssetsListElements.value.length === assetsList.value?.length) && !accessUrlElement.value.value.length) {
    // scroll to assets container
    const assetsFieldElement = ref(document.querySelector('.c-project__new-asset-form'))
    const assetsWarningElement = ref(document.querySelector('.c-project__new-asset-form .c-message--warning'))

    if (assetsFieldElement.value) {
      assetsFieldElement.value.scrollIntoView({ behavior: 'smooth' })

      if (assetsWarningElement.value) {
        assetsWarningElement.value.classList.remove('u-hide')
        assetsWarningElement.value.classList.remove('u-show')
      }
    }
  } else {
    // add new asset
    isLoading.value = true

    // disable actions buttons
    if (versionCancelCreateButton.value) {
      versionCancelCreateButtonDisabled.value = true
    }

    if (versionCancelEditButton.value) {
      versionCancelEditButtonDisabled.value = true
    }

    if (versionConfirmEditButton.value) {
      versionConfirmEditButtonDisabled.value = true
    }

    if (versionDeleteButton.value) {
      versionDeleteButtonDisabled.value = true
    }

    if (assetCancelEditButton.value) {
      assetCancelEditButtonDisabled.value = true
    }

    if (assetConfirmEditButton.value) {
      assetConfirmEditButtonDisabled.value = true
    }

    if (assetDeleteButton.value) {
      assetDeleteButtonDisabled.value = true
    }

    emit('addNewAsset', newAsset.value)
  }
}

// asset platform
function setPlatformName (name: string) {
  const str = String(name)

  let assetPlatformName: string

  switch (str) {
    case '0':
      assetPlatformName = 'macOS'
      break
    case '1':
      assetPlatformName = 'Windows'
      break
    case '2':
      assetPlatformName = 'Linux'
      break
    case '3':
      assetPlatformName = 'Other'
      break
    case '4':
      assetPlatformName = ''
      break
    default:
      assetPlatformName = ''
      break
  }

  return assetPlatformName
}

// asset validation
const isAssetUploading = ref(false)
const isAssetError = ref(false)
const showAssetUploading = ref(false)
const showAssetError = ref(false)
watchEffect(() => {
  if (!isAssetError.value) {
    showAssetError.value = false
  }
  if (!isAssetUploading.value) {
    showAssetUploading.value = false
  }
})

function validateAssets (): boolean {
  // it is not possible to use Constraint Validation API
  // because file input is hidden and fieldset is always valid
  // see https://developer.mozilla.org/en-US/docs/Web/API/HTMLFieldSetElement#methods
  showAssetUploading.value = false
  showAssetError.value = false

  let valid = true
  if (!isAssetUploading.value) {
    showAssetUploading.value = true
    valid = false
  }
  if (!isAssetError.value) {
    showAssetError.value = true
    valid = false
  }
  return valid
}

const confirmVersionDelete = ref(false)

function confirmVersionDeletion () {
  // ask user confirmation
  if (confirmVersionDelete.value === false) {
    confirmVersionDelete.value = true
    return
  }
  confirmVersionDelete.value = false

  isLoading.value = true

  // disable actions buttons
  if (versionCancelCreateButton.value) {
    versionCancelCreateButtonDisabled.value = true
  }

  if (versionCancelEditButton.value) {
    versionCancelEditButtonDisabled.value = true
  }

  if (versionConfirmEditButton.value) {
    versionConfirmEditButtonDisabled.value = true
  }

  if (versionDeleteButton.value) {
    versionDeleteButtonDisabled.value = true
  }

  if (assetCancelEditButton.value) {
    assetCancelEditButtonDisabled.value = true
  }

  if (assetConfirmEditButton.value) {
    assetConfirmEditButtonDisabled.value = true
  }

  if (assetDeleteButton.value) {
    assetDeleteButtonDisabled.value = true
  }

  emit('deletedVersion')
}

const confirmAssetDelete = ref(false)

function confirmAssetDeletion () {
  // ask user confirmation
  if (confirmAssetDelete.value === false) {
    confirmAssetDelete.value = true
    return
  }
  confirmAssetDelete.value = false

  isLoading.value = true

  // disable actions buttons
  if (versionCancelCreateButton.value) {
    versionCancelCreateButtonDisabled.value = true
  }

  if (versionCancelEditButton.value) {
    versionCancelEditButtonDisabled.value = true
  }

  if (versionConfirmEditButton.value) {
    versionConfirmEditButtonDisabled.value = true
  }

  if (versionDeleteButton.value) {
    versionDeleteButtonDisabled.value = true
  }

  if (assetCancelEditButton.value) {
    assetCancelEditButtonDisabled.value = true
  }

  if (assetConfirmEditButton.value) {
    assetConfirmEditButtonDisabled.value = true
  }

  if (assetDeleteButton.value) {
    assetDeleteButtonDisabled.value = true
  }

  emit('deletedAsset')
}

function removeAsset () {
  confirmAssetDelete.value = !confirmAssetDelete.value

  const deleteAssetButton = ref(document.getElementsByClassName('delete-button-assets-edit')[0] as HTMLElement)
  deleteAssetButton.value.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' })
}

async function submit () {
  if (isEditAssets.value) {
    if (!validateAssets()) {
      return
    }
  }
  const accessUrlElement = ref(document.querySelector('#asset-upload-link') as HTMLInputElement)

  if ((props.modelValue.assets.length !== 0) || accessUrlElement.value.innerText) {
    isLoading.value = true

    // update versions order
    for (const index in versionsList.value) {
      const body = {
        name: versionsList.value[parseInt(index)].name,
        description: versionsList.value[parseInt(index)].description,
        release_order: parseInt(index)
      }
      await editProjectVersionOrder(versionsList.value[parseInt(index)].pk, body)
    }
    emit('updateVersionsOrder', versionsList.value as unknown as Version[])

    // update tagged version
    if (versionsList.value) {
      const versionToTag = await getTaggedVersion()
      // console.log('versionToTag: ', versionToTag)

      if (versionToTag) {
        // loop through all versions in versionsList
        for (const index in versionsList.value) {
          const body = {
            name: versionsList.value[parseInt(index)].name,
            description: versionsList.value[parseInt(index)].description,
            // if version to tag pk is equal to a version in versionsList, set is_tagged to true, otherwise set to false
            is_tagged: versionsList.value[index].pk === versionToTag.pk
          }

          // update all versions is_tagged value through api
          await editProjectVersionTagged(versionsList.value[parseInt(index)].pk, body)
        }
        // emit versionsList to update is_tagged value in parent component
        emit('updateVersionsTagged', versionsList.value as unknown as Version[])
      }
    }

    emit('submitVersion')
  }
}

async function saveAsset () {
  if (isEditAssets.value) {
    if (!validateAssets()) {
      return
    }
  }

  emit('saveAsset')
}

async function submitAssets () {
  if (isEditAssets.value) {
    if (!validateAssets()) {
      return
    }
  }

  isLoading.value = true

  emit('submitAsset')
}

const { t } = useI18n({
  messages: {
    en: {
      createNewVersion: 'Create a version',

      name: 'Name',
      nameHint: '',

      description: 'Description',
      descriptionHint: 'Displayed below the version name in most case.',

      versionNumber: 'Version number',
      versionNumberHint: 'The release version number, preferably using <a href="https://semver.org/" target="_blank">semantic versioning.</a>',

      publicationDate: 'Date of publication',

      releaseNotes: 'Notes',
      releaseNotesHint: 'Displayed in a pop-up',

      status: 'Status',
      statusHint: 'Makes the project accessible by you only and prevents it from showing up in collections and search results. The repository and the discussion room will still be accessible to the public.',

      published: 'Published',
      draft: 'Draft',
      archived: 'Archived',

      createNewAsset: 'Add a link or file',

      assets: 'Assets',

      upload: 'Upload',

      platform: 'Platform',
      other: 'Other',

      premium: 'Premium access',

      unknownErrorCreate: 'An error occurred while trying to create the version, try again. If this keeps happening, please contact us.',
      unknownErrorEdit: 'An error occurred while trying to edit the version, try again. If this keeps happening, please contact us.',

      createVersion: 'Create the version',
      createInfo: `
        Please consider the version public once created.<br>
        Subscribers will receive an e-mail alert about the new version.
      `,

      addNewVersion: 'Add new version',

      editVersion: 'Edit version',
      saveVersion: 'Save version',

      addNewAsset: 'Add new asset',

      editAsset: 'Edit asset',
      saveAsset: 'Save asset',

      assetNameHint: '(required)',

      assetUploading: 'Please wait until the end of file upload...',
      assetError: 'Please remove files which did not upload',
      assetUploadWarning: 'Please upload a file or add an url',
      noAssetsUploaded: 'No assets were uploaded in this version.',

      assetUnlockUrl: 'Asset unlock url',

      clickAgainToConfirm: 'Click again to confirm',

      deleteVersionTaggedWarning: 'Please untag the version before deleting it',
      deleteLastAssetWarning: 'Please make sure you have at least one asset in your version.',

      save: 'Save and add asset',
      cancel: 'Cancel',
      delete: 'Delete'
    },
    fr: {
      createNewVersion: 'Créer une version',

      name: 'Nom',
      nameHint: '',

      description: 'Description',
      descriptionHint: 'Affiché sous le nom de la release',

      versionNumber: 'Numéro de version',
      versionNumberHint: 'Numéro de version de la release selon un <a href="https://semver.org/">schéma sémantique</a> de préférence.',

      publicationDate: 'Date de publication',

      releaseNotes: 'Notes',
      releaseNotesHint: 'Affiché dans un pop-up',

      status: 'Statut',
      statusHint: "Rends le projet accessible par vous uniquement et l'empêche d'apparaître dans les collections et les résultats de recherche. Le dépôt et le salon de discussion seront toujours accessibles.",

      published: 'Publié',
      draft: 'Brouillon',
      archived: 'Archivé',

      createNewAsset: 'Ajouter un lien ou un fichier',

      assets: 'Fichiers',

      upload: 'Upload',

      platform: 'Platforme',
      other: 'Autre',

      premium: 'Accès premium',

      unknownErrorCreate: 'Une erreur est survenue lors de la création de la version, merci de réessayer. Si le problème se reproduit, merci de nous contacter.',
      unknownErrorEdit: 'Une erreur est survenue l\'édition de la version, merci de réessayer.Si le problème se reproduit, merci de nous contacter.',

      createVersion: 'Créer la version',
      createInfo: `
        Merci de considérer que la version est publique une fois créée.<br>
        Les personnes ayant souscris aux alertes du projet recevront un e-mail
        à propos de la nouvelle version.
      `,

      addNewVersion: 'Ajouter une version',

      editVersion: 'Edition de version',
      saveVersion: 'Enregistrer la version',

      addNewAsset: 'Ajouter un asset',

      editAsset: 'Edition d\'asset',
      saveAsset: 'Enregistrer l\'asset',

      assetNameHint: '(requis)',

      assetUploading: 'Veuillez attendre la fin du chargement des fichiers...',
      assetError: "Veuillez supprimer les fichiers qui n'ont pas été téléversés",
      assetUploadWarning: 'Veuillez ajouter un fichier ou une url',
      noAssetsUploaded: "Aucun fichier n'a été téléversé dans cette version",

      assetUnlockUrl: "Lien de déverouillage de l'asset",

      clickAgainToConfirm: 'Re-cliquer pour confirmer',

      deleteVersionTaggedWarning: 'Veuillez ne pas tagguer la version avant de la supprimer',
      deleteLastAssetWarning: 'Veuillez vous assurer que la version possède au moins un asset.',

      save: 'Enregistrer et ajouter un asset',
      cancel: 'Annuler',
      delete: 'Supprimer'
    }
  }
})
</script>

<style lang="scss" scoped>
@use "@/sass/utilities/list_group";

</style>
